module.exports = __webpack_public_path__ + "static/front/img/avatar.060de95a.svg";